/**
 * PendingOrders — linhas pendentes (sem stock Rangel) + sugestões.
 * JA: "Não comunicar ao cliente trocas/libertações."
 */
import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api.js';
import { useTableProfile } from '../../hooks/useTableProfile.js';
import { DataTable } from '@shared/UI/DataTable';
import '@shared/UI/DataTable/DataTable.css';

const PendingOrders = () => {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState([]);
  const { layoutConfig, saveLayout } = useTableProfile('gencrm_pending');

  const load = async () => {
    setLoading(true);
    try {
      // Usa report /reports/pendentes para sourcing
      const r = await api.get('/reports/pendentes');
      setPending(r.data);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const columns = useMemo(() => [
    { key: 'order_number', label: 'Ordem', width: 120, render: (p) => <Link to={`/cockpit/orders/${p.order_id}`}>#{p.order_number}</Link> },
    { key: 'line_number', label: 'Ln', width: 70 },
    { key: 'customer_name', label: 'Cliente', width: 200 },
    { key: 'product_name', label: 'Produto', width: 240 },
    { key: 'quantity', label: 'Qty Pend', width: 100, aggregate: 'sum' },
    { key: 'rangel_stock', label: 'Stock Rangel', width: 120, render: (p) => (
      p.rangel_stock > 0
        ? <span className="gencrm_badge gencrm_badge--green">{p.rangel_stock}</span>
        : <span className="gencrm_badge gencrm_badge--red">0</span>
    ) },
    { key: 'pending_reason', label: 'Motivo', width: 160, render: (p) => p.pending_reason || '—' },
    { key: 'acao', label: 'Ação', width: 110, hideable: false, render: (p) => (
      p.rangel_stock > 0 ? <button className="gencrm_btn gencrm_btn--xs gencrm_btn--primary">Libertar</button> : null
    ) },
  ], []);

  return (
    <div className="gencrm_cockpit_pending">
      <div className="gencrm_alert gencrm_alert--info">
        💡 Pendentes = stock Rangel 0 (não SAP). Libertar gera nova ordem.
        <strong> Não comunicar trocas ao cliente.</strong>
      </div>

      {error && <div className="gencrm_ws_error">Erro: {error}</div>}

      <DataTable
        columns={columns}
        data={pending}
        rowKey={(p) => p.id}
        loading={loading}
        enableSelection
        onSelectionChange={(rows) => setSelected(rows.map((r) => r.id))}
        pageSize={20}
        density="compact"
        enableTotals
        emptyText="Sem pendentes."
        exportPrefix="gencrm_pending"
        layoutConfig={layoutConfig}
        onLayoutChange={saveLayout}
      />
    </div>
  );
};

export default PendingOrders;
